import React from 'react';
import DAVE from '../images/dave.jpg';
import JOHN from '../images/john.jpg'
import STEVE from '../images/steve.jpg'
import BUS from '../images/bus-companies.svg';
import COMP1 from '../images/company1.avif';
import COMP2 from '../images/company2.avif';
import COMP3 from '../images/company3.avif';
import COMP4 from '../images/company4.avif';
import COMP5 from '../images/company5.avif';
import COMP6 from '../images/company6.avif';

const TravelBloggerHome = () => {
    return (
        <div className='mx-5 mt-8 lg:ml-40 lg:mr-40 lg:mt-16  flex-col flex items-center justify-center'>
            <p className='py-2  inline font-semibold text-lg bg-[#e7f7fe] px-5 lg:py-1 rounded-xl mb-7 '>Travel Bloggers around the world trust BlueBus</p>
            <div className="lg:flex lg:gap-8 lg:mt-5 ">
                <div className='mb-4 lg:mb-0'>
                    <p className='pb-1 lg:pb-2 text-gray-500'>I don’t know of another website as comprehensive as this one. They do a really good job.</p>
                    <div className='flex gap-2 items-center '>
                        <img src={DAVE} className='rounded-full w-10 h-10 ' />
                        <div>
                            <p className='text-sm'>Dave</p>
                            <p className='text-gray-300 text-sm'>Nomadic Matt</p>
                        </div>


                    </div>
                    <div className='border border-gray-200 h-0 w-[100%] mt-3 lg:hidden'></div>
                </div>
                <div className='mb-4 lg:mb-0'>
                    <p className='pb-1 lg:pb-2 text-gray-500'>I found that Busbud's website and mobile app were exceptionally easy to use.</p>
                    <div className='flex gap-2 items-center'>
                        <img src={JOHN} className='rounded-full w-10 h-10 ' />
                        <div>
                            <p className='text-sm'>John</p>
                            <p className='text-gray-300 text-sm'>Department of Wandering</p>
                        </div>


                    </div>
                    <div className='border border-gray-200 h-0 w-[100%] mt-3 lg:hidden'></div>
                </div>
                <div className='mb-4 lg:mb-0'>
                    <p className='pb-1 lg:pb-2 text-gray-500'>Bluebus leaves room for spontaneity and last minute travel changes.</p>
                    <div className='flex gap-2 items-center '>
                        <img src={STEVE} className='rounded-full w-10 h-10 ' />
                        <div>
                            <p className='text-sm'>Steve</p>
                            <p className='text-gray-300 text-sm'>GQ Trippin</p>
                        </div>


                    </div>
                    <div className='border border-gray-200 h-0 w-[100%] mt-3 lg:hidden'></div>
                </div>

            </div >
            <div className='hidden lg:block border border-gray-200 mt-16 mb-12 h-0 w-[100%]'></div>


            <div className='mt-12 flex flex-col items-center justify-center lg:mt-2 gap-4'>
                <img src={BUS}></img>
                <p className='text-2xl font-bold text-gray-600'>We’ve partnered with the world’s most popular bus companies</p>
                <div className='flex flex-wrap justify-center mt-4 '>
                    <div className='p-12 border'><img src={COMP1} className='w-48 h-30 '></img></div>
                    <div className='p-12 border'><img src={COMP2} className='w-48 h-30 '></img></div>
                    <div className='p-12 border'><img src={COMP3} className='w-48 h-30 '></img></div>
                    <div className='p-12 border'><img src={COMP4} className='w-48 h-30 '></img></div>
                    <div className='p-12 border'><img src={COMP5} className='w-48 h-30 '></img></div >
                    <div className='p-12 border'> <img src={COMP6} className='w-48 h-30 '></img></div>
                </div >
            </div >
        </div >
    )
}

export default TravelBloggerHome
